import { ElementType, HTMLAttributes } from 'react'

import { layoutCss } from './styles'

interface Props extends HTMLAttributes<HTMLElement> {
  tag?: ElementType
}

const Container = ({ tag: Tag = 'div', ...rest }: Props) => (
  <Tag css={layoutCss} className="container" {...rest} />
)

export default Container
